/**
 * Labstep
 *
 * @module components/ResourceItem/Manager/Template
 * @desc Manager for ResourceItem template
 */

import { ResourceItemPreviewTemplate } from 'labstep-web/components/ResourceItem/Preview/Template';
import { ResourceItemTemplateEmptyState } from 'labstep-web/components/ResourceItemTemplate/EmptyState';
import type React from 'react';
import type { IResourceItemManagerTemplateProps } from './types';

export const ResourceItemManagerTemplate: React.FC<
  IResourceItemManagerTemplateProps
> = ({ resource }) =>
  resource.hasNonDeletedResourceItemTemplate ? (
    <ResourceItemPreviewTemplate
      resourceItem={resource.resource_item_template!}
      showDisableButton={!resource.is_template}
    />
  ) : (
    <ResourceItemTemplateEmptyState resource={resource} />
  );
